export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'fltSysEventLog';
export const NAME = 'LogSystemUdalosti';
